export default "__VITE_ASSET__21de5daf__"